(function () {
  'use strict';

  var STORAGE_KEY = 'wynch_footer_manifest_invite_seen_v1';
  var ACTIVE_CLASS = 'is-attention-active';
  var READY_ATTRIBUTE = 'data-wynch-footer-motion-ready';
  var FALLBACK_DURATION_MS = 1800;

  function motionIsReduced() {
    return typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function invitationWasSeen() {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY) === 'true';
    } catch (error) {
      // Suppress automatic motion when session persistence is unavailable.
      return true;
    }
  }

  function markInvitationSeen() {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, 'true');
      return true;
    } catch (error) {
      return false;
    }
  }

  function playInvitation(link) {
    if (motionIsReduced() || invitationWasSeen() || !markInvitationSeen()) return;

    var fallbackTimer;
    var finish = function () {
      link.classList.remove(ACTIVE_CLASS);
      if (fallbackTimer) window.clearTimeout(fallbackTimer);
      link.removeEventListener('pointerenter', finish);
      link.removeEventListener('focus', finish);
    };

    link.addEventListener('pointerenter', finish, { once: true });
    link.addEventListener('focus', finish, { once: true });
    link.classList.add(ACTIVE_CLASS);
    fallbackTimer = window.setTimeout(finish, FALLBACK_DURATION_MS);
  }

  function observeInvitation(link) {
    if (motionIsReduced() || invitationWasSeen()) return;
    if (typeof window.IntersectionObserver !== 'function') return;

    var observer = new window.IntersectionObserver(function (entries) {
      var visible = entries.some(function (entry) {
        return entry.target === link && entry.isIntersecting && entry.intersectionRatio >= 0.5;
      });
      if (!visible || document.visibilityState === 'hidden') return;

      observer.disconnect();
      playInvitation(link);
    }, { threshold: 0.5 });

    observer.observe(link);
  }

  function initialize(root) {
    var link = root.querySelector('[data-wynch-footer-manifest-link]');
    if (!link || link.hasAttribute(READY_ATTRIBUTE)) return;

    link.setAttribute(READY_ATTRIBUTE, 'true');
    observeInvitation(link);
  }

  function initializeAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-wynch-footer-manifest]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
